import React from "react";
import { Download } from "lucide-react";
import { LEAD_MAGNET_FILE, LEAD_MAGNET_FILENAME } from "../lib/leadMagnet";

export const OptInBlueprint = () => {
    return (
        <section
            data-testid="optin-blueprint"
            style={{ background: "var(--brr-bg-2)" }}
            className="border-y border-[color:var(--brr-border)]"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    <div className="lg:col-span-7 reveal">
                        <span className="brr-overline">
                            Reader Bonus · Free Download
                        </span>
                        <h2
                            data-testid="optin-headline"
                            className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] mt-5"
                        >
                            Get the Free{" "}
                            <span className="italic">Better Rest</span>{" "}
                            Blueprint.
                        </h2>
                        <p
                            data-testid="optin-subheadline"
                            className="mt-6 text-lg font-light leading-relaxed text-[color:var(--brr-ink-2)] max-w-xl"
                        >
                            A simple 7-day pillow comfort checklist for adults
                            who want a cleaner, more supportive rest setup.
                        </p>

                        <ul className="mt-8 space-y-3 max-w-lg">
                            {[
                                "A 7-day editorial routine you can follow at your own pace",
                                "What to look for in a considered contour pillow",
                                "Small bedroom rituals that quietly shape a calmer night",
                            ].map((item) => (
                                <li
                                    key={item}
                                    className="flex items-start gap-3 text-[15px] leading-relaxed font-light text-[color:var(--brr-ink)]"
                                >
                                    <span
                                        className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0"
                                        style={{
                                            background:
                                                "var(--brr-blue-hover)",
                                        }}
                                    />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-10 flex flex-col sm:flex-row gap-5 items-start sm:items-center">
                            <a
                                data-testid="optin-cta-download"
                                href={LEAD_MAGNET_FILE}
                                download={LEAD_MAGNET_FILENAME}
                                className="btn-primary"
                            >
                                Download Free Guide
                                <Download size={16} strokeWidth={1.75} />
                            </a>
                            <span className="text-xs tracking-[0.18em] uppercase opacity-60">
                                Free PDF · No account required
                            </span>
                        </div>
                    </div>

                    <aside className="lg:col-span-5 reveal">
                        <div
                            data-testid="optin-card"
                            className="relative bg-white border border-[color:var(--brr-border)] rounded-2xl p-8 md:p-10 overflow-hidden"
                            style={{
                                boxShadow:
                                    "0 30px 80px -40px rgba(28,40,51,0.18)",
                            }}
                        >
                            <div
                                className="absolute -top-16 -right-16 w-56 h-56 rounded-full opacity-50"
                                style={{
                                    background: "var(--brr-blue-soft)",
                                }}
                            />
                            <div className="relative">
                                <span className="brr-overline">
                                    The Blueprint
                                </span>
                                <p className="font-serif-display text-2xl sm:text-3xl mt-4 leading-snug">
                                    Seven mornings.
                                    <br />
                                    <span className="italic">
                                        One quiet routine.
                                    </span>
                                </p>
                                <ol className="mt-7 space-y-2.5 text-[14px] font-light leading-relaxed text-[color:var(--brr-ink-2)]">
                                    {[
                                        "Day 1 · Audit your current pillow",
                                        "Day 2 · Check the silhouette and loft",
                                        "Day 3 · Refresh the cover and air the fill",
                                        "Day 4 · Match the loft to your sleep position",
                                        "Day 5 · Review the bedroom around the pillow",
                                        "Day 6 · A small bedtime ritual to keep",
                                        "Day 7 · Choose what comes next",
                                    ].map((line, i) => (
                                        <li
                                            key={line}
                                            data-testid={`optin-day-${i + 1}`}
                                            className="flex items-start gap-3"
                                        >
                                            <span
                                                className="issue-tag text-sm"
                                                style={{ minWidth: "1.5rem" }}
                                            >
                                                {String(i + 1).padStart(2, "0")}
                                            </span>
                                            <span>{line.split("· ")[1]}</span>
                                        </li>
                                    ))}
                                </ol>
                                <p className="mt-8 text-[11px] tracking-[0.18em] uppercase opacity-60">
                                    PDF · Better Rest Report · Editorial
                                </p>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </section>
    );
};
